const attributes = {
  headerSticky: "data-header-sticky",
  headerMenu: "data-header-menu",
  headerMenuTrigger: "data-header-menu-trigger",
  headerSubMenu: "data-header-submenu",
  headerSubMenuTrigger: "data-header-submenu-trigger",
};

const selectors = {
  header: "[data-header]",
  headerOverlay: "[data-header-overlay]",
  headerMenu: `[${attributes.headerMenu}]`,
  headerMenuTrigger: `[${attributes.headerMenuTrigger}]`,
  headerSubMenu: `[${attributes.headerSubMenu}]`,
  headerSubMenuTrigger: `[${attributes.headerSubMenuTrigger}]`,
  headerSticky: `[${attributes.headerSticky}]`,
  headerStickyTrigger: "[data-header-sticky-trigger]",
};

const setScrollPadding = ({ header }) => {
  const { height } = header.getBoundingClientRect();

  document.documentElement.style.setProperty("--scroll-padding-top", height + "px");
};

const toggleHeaderMenu = (menu, isActive) =>
  menu.setAttribute(
    attributes.headerMenu,
    typeof isActive == "boolean" ? +isActive : +!+menu.getAttribute(attributes.headerMenu)
  );

const toggleHeaderSubMenuTrigger = (submenu, activeSubMenu, activeSubMenuTrigger) => {
  submenu.forEach(({ triggers }, subMenuIndex) => {
    triggers.forEach((trigger, subMenuTriggerIndex) =>
      trigger.setAttribute(
        attributes.headerSubMenuTrigger,
        subMenuIndex === activeSubMenu && subMenuTriggerIndex === activeSubMenuTrigger
          ? !+trigger.getAttribute(attributes.headerSubMenuTrigger)
            ? +true
            : +false
          : +false
      )
    );
  });
};

const toggleHeaderSubMenu = (submenu, activeIndex) =>
  submenu.forEach(({ element }, index) =>
    element.setAttribute(
      attributes.headerSubMenu,
      index === activeIndex
        ? !+element.getAttribute(attributes.headerSubMenu)
          ? +true
          : +false
        : +false
    )
  );

const toggleHeaderMenuTriggers = (triggers) =>
  triggers.forEach((trigger) =>
    trigger.setAttribute(
      attributes.headerMenuTrigger,
      +!+trigger.getAttribute(attributes.headerMenuTrigger)
    )
  );

const initHeaderOverlay = ({ overlay, menu, submenu }) =>
  overlay.addEventListener("click", () => {
    toggleHeaderMenu(menu.menu, false);
    toggleHeaderMenuTriggers(menu.triggers);
    toggleHeaderSubMenu(submenu, -1);
    toggleHeaderSubMenuTrigger(submenu, -1, -1);
  });

const initHeaderSticky = ({ header, stickyTrigger }) => {
  const observer = new IntersectionObserver(
    ([intersection]) => {
      !intersection.isIntersecting
        ? header.setAttribute(attributes.headerSticky, "")
        : header.removeAttribute(attributes.headerSticky);
    },
    {
      root: null,
      threshold: 1,
    }
  );

  observer.observe(stickyTrigger);
};

const initHeaderMenuTriggers = ({ menu, submenu }) =>
  menu.triggers?.forEach((trigger, activeIndex) =>
    trigger.addEventListener("click", () => {
      toggleHeaderMenu(menu.menu);
      toggleHeaderMenuTriggers(menu.triggers);
      toggleHeaderSubMenu(submenu, -1);
      toggleHeaderSubMenuTrigger(submenu, -1, -1);
    })
  );

const initHeaderSubMenuTriggers = ({ submenu }) =>
  submenu?.forEach(({ triggers, element }, activeSubMenuIndex) => {
    triggers?.forEach((trigger, activeSubMenuTriggerIndex) =>
      trigger.addEventListener("click", () => {
        toggleHeaderSubMenu(submenu, activeSubMenuIndex);
        toggleHeaderSubMenuTrigger(submenu, activeSubMenuIndex, activeSubMenuTriggerIndex);
      })
    );
  });

document.addEventListener(
  "DOMContentLoaded",
  async function () {
    const header = document.querySelector(selectors.header);

    if (!header) return;

    const elements = {
      header: header,
      stickyTrigger: document.querySelector(selectors.headerStickyTrigger),
      overlay: header.querySelector(selectors.headerOverlay),
      menu: {
        menu: header.querySelector(selectors.headerMenu),
        triggers: [...header.querySelectorAll(selectors.headerMenuTrigger)],
      },
      submenu: [...header.querySelectorAll(selectors.headerSubMenu)].map((submenu) => ({
        element: submenu,
        triggers: [
          ...header.querySelectorAll(
            `[${attributes.headerSubMenuTrigger}=${submenu.getAttribute(attributes.headerSubMenu)}]`
          ),
        ],
      })),
    };

    initHeaderMenuTriggers(elements);
    initHeaderSubMenuTriggers(elements);
    initHeaderOverlay(elements);
    initHeaderSticky(elements);
    setScrollPadding(elements);
  },
  {
    once: true,
  }
);
